export default function (state = [], action) {
    switch (action.type) {
        case "CUSTOM_COLORS_SELECTED":
            return action.payload;
        default:
            return state;
    }
}